import React from 'react';
import { FiPhone, FiMail, FiClock } from 'react-icons/fi';
import siteData from '../data/siteData';

function TopBar() {
  const { phone_number, email_address } = siteData.top_bar;
  return (
    <div className="topbar-container">
      <div className="container topbar-inner">
        <div className="topbar-left">
          <FiClock size={13} />
          <span>Mon – Sat: 10:00 AM – 7:00 PM</span>
        </div>
        <div className="topbar-right">
          {phone_number && (
            <a href={`tel:${phone_number.replace(/\s/g, '')}`} className="topbar-item">
              <FiPhone size={13} />
              <span>{phone_number}</span>
            </a>
          )}
          {email_address && (
            <a href={`mailto:${email_address}`} className="topbar-item">
              <FiMail size={13} />
              <span>{email_address}</span>
            </a>
          )}
        </div>
      </div>
    </div>
  );
}

export default TopBar;
